import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { useGroupSubscription } from '@repo/ui/hooks/api/subscription/use-group-subscription';
import { useGetCurrentUser } from '@repo/ui/hooks/api/users/use-current-user';
import { lazy, Suspense } from 'react';

const SubscriptionManagement = lazy(() =>
  import('@repo/ui/features/subscription/index').then((mod) => ({ default: mod.SubscriptionManagement })),
);

export default function SubscriptionPage() {
  const { data: currentUser, isLoading: isUserLoading } = useGetCurrentUser();
  const groupeId = currentUser?.data?.groupe?.id as number | undefined;
  const { data: groupSubscription, isLoading: isSubscriptionLoading } =
    useGroupSubscription(groupeId);

  if (isUserLoading || isSubscriptionLoading) {
    return <DendromapLoader message="Chargement de l'abonnement..." />;
  }

  if (!groupeId) {
    return (
      <p className="text-sm text-muted-foreground">
        Impossible de charger les informations d&apos;abonnement pour votre compte.
      </p>
    );
  }

  const currentPlanType =
    (groupSubscription?.plan_type as 'BASIC' | 'ADVANCED' | undefined) ?? 'BASIC';
  const currentTierId = groupSubscription?.tier_id ?? '';

  return (
    <div className="w-full">
      <Suspense fallback={<DendromapLoader message="Chargement de l'abonnement..." />}>
        <SubscriptionManagement
          groupeId={groupeId}
          currentPlanType={currentPlanType}
          currentTierId={currentTierId}
        />
      </Suspense>
    </div>
  );
}
